import { Center, Checkbox, Skeleton } from '@chakra-ui/react';
import CustomDataTableEditBtn from '@Modules/core/components/table/CustomDataTableEditBtn';
import { createColumnHelper } from '@tanstack/react-table';

export type TAssetsDataTableData = {
  primaryKey: string | number,
  assetsDescription: string  | number,
  account: string,
  accountHolderName: string,
  flowSubject: boolean,
  value: number | string,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any, table: "assets" | "income") => void,
};

const columnHelper = createColumnHelper<TAssetsDataTableData>();

export function getAssetsDataTableColumns({ isLoading, handleEdit }: Props) {
  return [
    columnHelper.accessor('assetsDescription', {
      id: 'assetsDescription',
      header: 'Description des Biens',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('account', {
      id: 'account',
      header: 'Compte',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('accountHolderName', {
      id: 'accountHolderName',
      header: 'Nom du Détenteur du Compte',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('flowSubject', {
      id: 'flowSubject',
      header: 'Sujet au Débit',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>
            <Center><Checkbox checked={!!props.getValue()} isReadOnly></Checkbox></Center>
        </Skeleton>;
      },
    }),
    columnHelper.accessor('value', {
      id: 'value',
      header: 'Valeur',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.display({
      id: 'action',
      header: '',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>
              <CustomDataTableEditBtn onClick={() => handleEdit(props.row, "assets")} />
            </Center>
          </Skeleton>
        );
      },
    }),
  ];
}
